import { fetchWrapper } from "@helpers/fetchwrapper";

export const CAREER_CENTER_PAGE_TYPE = 8;
export const CAREER_CENTER_TAB = "career-center";

export function fetchCareerCenterPages(offset, limit) {
  return fetchWrapper.post(
    `/v1/api/app/GetPagesByTypesWithCompanies?offset=${offset}&limit=${limit}`,
    [CAREER_CENTER_PAGE_TYPE]
  );
}

export function filterPagesWithCompany(pages) {
  return (pages || []).filter((page) => page.IdCompany != null);
}

export function getCompanyBasePath(company) {
  if (!company?.Slug) {
    return null;
  }

  if (company.IdType === 1) {
    return `/company/${company.Slug}`;
  }

  if (company.IdType === 2) {
    return `/obrazovanie-v-bashkortostane/vuzy-rb/${company.Slug}`;
  }

  if (company.IdType === 4) {
    return `/obrazovanie-v-bashkortostane/shkoly-rb/${company.Slug}`;
  }

  return `/obrazovanie-v-bashkortostane/kolledzhi-rb/${company.Slug}`;
}

export function getCompanyCareerCenterPath(company) {
  const basePath = getCompanyBasePath(company);

  if (!basePath) {
    return null;
  }

  return `${basePath}?tab=${CAREER_CENTER_TAB}`;
}

export async function enrichPagesWithCompanies(pages) {
  if (!pages?.length) {
    return [];
  }

  const companyIds = [
    ...new Set(pages.map((page) => page.IdCompany).filter(Boolean)),
  ];

  if (!companyIds.length) {
    return pages;
  }

  const companies = await Promise.all(
    companyIds.map((id) =>
      fetchWrapper.get(`/v1/api/app/company/${id}`).catch(() => null)
    )
  );

  const companyById = new Map();
  companies.forEach((company) => {
    if (company?.Id) {
      companyById.set(company.Id, company);
    }
  });

  return pages.map((page) => ({
    ...page,
    company: page.IdCompany ? companyById.get(page.IdCompany) || null : null,
  }));
}

export function getPageCardLink(item) {
  if (item.company) {
    return getCompanyCareerCenterPath(item.company);
  }

  if (item.SlugCompany) {
    const company = {
      Slug: item.SlugCompany,
      IdType: item.CompanyIdType ?? 3,
    };
    return getCompanyCareerCenterPath(company);
  }

  return item.Slug ? `/page/${item.Slug}` : null;
}
